<template>
  <div class="right-pane">
    <div class="head-top clearfix">
      <div class="head-top-l fl" style="height:50px;width: calc(100% - 400px);position: relative;">

	    </div>
      <div class="head-top-r fr">
        <ul class="clearfix">
          <!-- <li class="icon_li pt-5 hover_li" @click="openSmsFn" v-if="GLOBAL.power.is_1010">
            <i class="iconfont icona-008duanxin font-22 blue"></i>
            <p>{{Language('短信')}}</p>
          </li>
          <li class="icon_li pt-5 hover_li" @click="goToUrl('Email/EmailCreate')" v-if="GLOBAL.power.is_1020">
            <i class="iconfont icona-009youjian font-22 blue"></i>
            <p>{{Language('邮件')}}</p>
          </li> -->
          <li class="icon_li pt-5 hover_li" @click="goToUrl('MsgTips/MsgTips')">
            <template v-if="messageNum==0">
              <el-badge :max="99" hidden :value="messageNum">
                <i class="iconfont icona-013tongzhi font-22 blue"></i>
                <p>{{Language('通知')}}</p>
              </el-badge>
            </template>
            <template v-else>
              <el-popover placement="bottom" trigger="hover" width="280">
                <div slot="reference" :title="Language('通知')">
                  <el-badge :max="99" :hidden="messageNum==0" :value="messageNum">
                    <i class="iconfont icona-013tongzhi font-22 blue"></i>
                    <p>{{Language('通知')}}</p>
                  </el-badge>
                </div>
                <el-card shadow="never" v-for="(item, index) in tipsList" :key="item.id" class="bg_f3" :class="index!=0?'mt-10':''" :body-style="{padding: '0px'}">
                  <div class="right_top_card" @click="byIdGoToUrl('tip', item)">
                    <h4>{{ item.createDate }}</h4>
                    <p class="wrap-2">{{ item.content }}</p>
                  </div>
                </el-card>
                <div class="mt-10 text-center">
                  <el-button type="text" style="padding:0;" @click="goToUrl('MsgTips/MsgTips')">{{Language('查看更多')}}</el-button>
                </div>
              </el-popover>
            </template>
          </li>
          <!-- <li class="icon_li pt-5 hover_li" @click="goToUrl('Notic/MyNoticManagement')">
            <template v-if="noticNum==0">
              <el-badge :max="99" hidden :value="noticNum">
                <i class="iconfont icona-014gonggao font-22 blue"></i>
                <p>{{Language('公告')}}</p>
              </el-badge>
            </template>
            <template v-else>
              <el-popover placement="bottom" trigger="hover" width="280">
                <div slot="reference" :title="Language('公告')">
                  <el-badge :max="99" :hidden="noticNum==0" :value="noticNum">
                    <i class="iconfont icona-014gonggao font-22 blue"></i>
                    <p>{{Language('公告')}}</p>
                  </el-badge>
                </div>
                <el-card shadow="never" v-for="(item, index) in noticList" :key="item.id" class="bg_f3" :class="index!=0?'mt-10':''" :body-style="{padding: '0px'}">
                  <div class="right_top_card" @click="byIdGoToUrl('notice', item)">
                    <h4>{{ item.createDate }}</h4>
                    <p class="wrap-2">{{ item.title }}</p>
                  </div>
                </el-card>
                <div class="mt-10 text-center">
                  <el-button type="text" style="padding:0;" @click="goToUrl('Notic/MyNoticManagement')">{{Language('查看更多')}}</el-button>
                </div>
              </el-popover>
            </template>
          </li> -->
          <li>
            <el-popover placement="bottom-end" trigger="hover" width="280">
              <div slot="reference" :title="Language('个人信息')">
                <img class="avatarImg-s" :src="picPath" />
              </div>
              <div class="pop-item">
                <ul class="one-ul">
                  <li>{{Language('工号')}}<br>{{userObj.workNo}}</li>
                  <li>{{Language('姓名')}}<br>{{userObj.userName}}</li>
                  <li>{{Language('分机号')}}<br>{{userObj.extNum}}</li>
                </ul>
              </div>
              <div class="pop-item">
                <ul class="two-ul">
                  <li class="cur-p" @click="OpenInfo"><i class="iconfont icona-022xiugaimima mr-10"></i>{{Language('个人信息')}}</li>
                </ul>
              </div>
              <div class="pop-item" v-if="!hideTheme">
                <p>{{Language('设置主题')}}</p>
                <el-radio-group class="pop-radio-group w-100bf" v-model="bodyBgColor" @change="changeBgColor">
                  <template v-if="isTheme">
                    <el-radio label="qianse">{{Language('浅色')}}</el-radio>
                    <el-radio label="shense">{{Language('深色')}}</el-radio>
                  </template>
                  <template v-else>
                    <el-radio label="lanse">{{Language('蓝色')}}</el-radio>
                    <el-radio label="fense">{{Language('粉色')}}</el-radio>
                    <el-radio label="chengse">{{Language('橙色')}}</el-radio>
                    <el-radio label="huise">{{Language('灰色')}}</el-radio>
                    <el-radio label="lvse">{{Language('绿色')}}</el-radio>
                    <el-radio label="zise">{{Language('紫色')}}</el-radio>
                  </template>
                </el-radio-group>
              </div>
              <div class="pop-item" v-if="isTuichu">
                <div class="pop-logout" @click="logout">{{Language('退出账号')}}</div>
              </div>
            </el-popover>
          </li>
        </ul>
      </div>
    </div>
    <el-tabs class="tabs isBlock isPos" v-model="activeTabName" @tab-remove="closeTab" @contextmenu.prevent.native="openMenu" type="border-card">
      <template v-for="item in tabList">
        <el-tab-pane :ref="item.name" :key="item.name" :name="item.name" :label="Language(item.label)" :closable="item.closable" v-if="!item.disabled">
          <component v-if="item.isLoad" :is="item.component" style="height: 100%"></component>
        </el-tab-pane>
      </template>
    </el-tabs>

    <el-dialog :title="Language('个人信息')" :visible.sync="IsInfo" width="35%" :modal-append-to-body="false" custom-class="center-dialog setinfo-dialog"
      :close-on-press-escape="false" :close-on-click-modal="false" @close="closeBack('form_info')">
      <el-form :model="form_info" label-width="100px" ref="form_info" :rules="rules_form" class="new-form-center" size="small"
      style="padding-right: 0">
        <el-row>
          <el-col class="passWord-box">
            <!-- <el-form-item :label="Language('修改密码')">
              <el-switch v-model="isEditPwd" :active-value="true" :inactive-value="false"></el-switch>
            </el-form-item>
            <template v-if="isEditPwd">
              <el-form-item :label="Language('旧密码')" prop="oldPwd">
                <el-input type="password" v-model.trim="form_info.oldPwd" clearable autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="Language('新密码')" prop="newPwd">
                <el-input type="password" v-model.trim="form_info.newPwd" clearable autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="Language('确认新密码')" prop="checkNewPwd">
                <el-input type="password" v-model.trim="form_info.checkNewPwd" clearable autocomplete="off"></el-input>
              </el-form-item>
            </template> -->
            <el-form-item :label="Language('手机号码')" prop="mobileTel">
              <el-input v-model.trim="form_info.mobileTel" maxlength="20" clearable autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item :label="Language('联系电话')" prop="tel">
              <el-input v-model.trim="form_info.tel" maxlength="20" clearable autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item :label="Language('E-mail')" prop="email">
              <el-input v-model.trim="form_info.email" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item :label="Language('业务单元')" prop="buCode">
              <el-select v-model="form_info.buCode" placeholder="" clearable filterable class="w-100bf" disabled>
                <el-option v-for="item in codeList"
                  :key="item.code"
                  :label="item.codeText"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="avatarImg-box">
            <el-upload class="img-btn" ref="uploadAvatar" action="#" :show-file-list="false"  :before-upload="beforeAvatarUpload" 
              accept=".jpg,.jpeg,.png" :http-request="uploadImg" :on-change="handleUploadChange">
              <img class="avatarImg" :src="form_info.picPath" />
            </el-upload>
            <p class="avatarTips">
              <i class="iconfont iconzu font-14"></i>
              <span>{{Language('图片仅支持大小2M以内JPG、JPEG、PNG格式')}}</span>
            </p>
          </el-col>
        </el-row>
      </el-form>
      <!-- <div class="diglog-bom-box">
        <el-button type="primary" @click="setInfo('form_info')" size="small">{{Language('确 定')}}</el-button>
        <el-button @click="IsInfo = false" size="small">{{Language('取 消')}}</el-button>
      </div> -->
    </el-dialog>

    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li @click="refreshSelectedTag">{{Language('刷新')}}</li>
      <li @click="closeThis" v-if="thisMenu != '999' && thisMenu != '888' && thisMenu != '777'">{{Language('关闭')}}</li>
      <li @click="closeOthersTags">{{Language('关闭其他')}}</li>
      <li @click="closecloseAllTags">{{Language('关闭所有')}}</li>
    </ul>

    <el-dialog :title="Language('通讯录')" :visible.sync="linkBookShow" width="400px" :modal-append-to-body="false"
      custom-class="center-dialog setinfo-dialog" :close-on-press-escape="false" :close-on-click-modal="false" @close="closeLinkBookFn">
      <div class="pl-15 pr-15">
        <div class="transfer_item radio_tree">
          <el-radio-group v-model="checkPhone" class="w-100bf" v-if="linkBookOne">
            <el-tree ref="tree" :data="linkBookList" node-key="id">
              <div slot-scope="{data}">
                <span class="font-14" v-if="data.isType==1">{{data.label}}</span>
                <el-radio :label="data" v-else>{{data.label}}</el-radio>
              </div>
            </el-tree>
          </el-radio-group>
          <el-checkbox-group v-model="checkPhoneMore" class="w-100bf" v-else>
            <el-tree ref="tree" :data="linkBookList" node-key="id">
              <div slot-scope="{data}">
                <span class="font-14" v-if="data.isType==1">{{data.label}}</span>
                <el-checkbox :label="data" v-else>{{data.label}}</el-checkbox>
              </div>
            </el-tree>
          </el-checkbox-group>
        </div>
      </div>
      <div class="diglog-bom-box">
        <el-button type="primary" size="small" @click="setLinkBook">{{Language('确 定')}}</el-button>
        <el-button @click="closeLinkBookFn" size="small">{{Language('取 消')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="Language('发送短信')" :visible.sync="smsShow" width="800px" :modal-append-to-body="false" custom-class="center-dialog setinfo-dialog"
      :close-on-press-escape="false" :close-on-click-modal="false" @close="closeSmsFn">
      <el-form :model="sendForm" :rules="sendRules" label-width="100px" ref="sendForm" style="padding-right: 10px;width:90%;margin:0 auto;">
        <el-form-item :label="Language('短信模板')" prop="modelId">
          <el-cascader ref="smsTpl" :options="templateList" v-model="sendForm.modelId" clearable :show-all-levels="false"
            :props="{ expandTrigger: 'hover', emitPath: false, label: 'name', value: 'id' }" size="small"
            @change="setTemplateFn">
          </el-cascader>
        </el-form-item>
        <el-form-item :label="Language('短信签名')" prop="signtype">
          <el-select v-model="sendForm.signtype" :placeholder="Language('请选择')">
            <el-option v-for="item in smsSignList"
              :key="item.dictCode"
              :label="item.dictName"
              :value="item.dictCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="Language('短信内容')" prop="content">
          <p>{{Language('当前短信内容')}} <span class="numFlag">{{contentNumber}}</span> {{Language('字, 预计分')}} <span class="numFlag">{{sendContentNumber}}</span> {{Language('条发送。')}}</p>
          <el-input v-model="sendForm.content" type="textarea" :placeholder="Language('请输入短信内容')" v-if="contentTextareaShow"
            autocomplete="off"
            size="small"
            rows="8" @input="changeContentFn"></el-input>
          <div class="el-textarea__inner" style="min-height:168px" v-else>
            <span v-for="(item, index) in templateContentList" :key="index">
                <span v-if="item.type == 'text'">{{item.value}}</span>
                <el-input v-if="item.type == 'disabled'" v-model="item.value" :placeholder="item.placeholder" size="small" style='width:100px;height:32px' disabled></el-input>
                <el-input v-if="item.type == 'input'" v-model="item.value" :placeholder="item.placeholder" size="small" style='width:200px;height:32px' @input="changeContentFn" clearable></el-input>
            </span>
          </div>
        </el-form-item>
        <el-form-item :label="Language('优先级')" prop="priority">
          <el-select v-model="sendForm.priority">
            <el-option :label="Language('普通')" value="0"></el-option>
            <el-option :label="Language('紧急')" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="Language('短信接收人')">
          <div class="edit_p_box">
            <el-tag
              :key="tag.mobileNo"
              v-for="tag in dynamicTags"
              closable
              size="mini"
              :disable-transitions="false"
              @close="handleClose(tag)">
              {{formatterTel(tag)}}
            </el-tag>
          </div>
          <el-button type="text" size="small" @click="openLinkBookFn">{{Language('选择接收人')}}</el-button>
          <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="mini"
              :placeholder="Language('请填写手机号')"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button type="text" v-else class="button-new-tag" size="small" @click="showInput">{{Language('自定义手机号')}}</el-button>
        </el-form-item>
      </el-form>
      <div class="diglog-bom-box">
        <el-button type="primary" @click="sendSmsFn" size="small">{{Language('确 定')}}</el-button>
        <el-button @click="closeSmsFn" size="small">{{Language('取 消')}}</el-button>
      </div>
    </el-dialog>

    <MessageWS ref="wsBox" @msgObj="msgObjFn" @noticObj="noticObjFn"></MessageWS>
    
  </div>
</template>
<script>
import { getTimes } from "../Common/datetime.js"
import { logout, updateUserPwd } from "@/http/login"
import {
  getSkillListByUserId, getSkillList, getGroupList, getGroupListByUserId, getAgentListByGroupId,
  getSmsTemplateList, getDictList, getUserGroupAndSkillList, findBuCode
} from "@/http/BaseData"
import { addInfo } from "@/http/SmsTaskManagement.js"
import { orderFormDesignGetList } from "@/http/formManagement.js"
import { orderTypeGetList } from '@/http/orderTypeManagement.js'
import { cusLevelGetList } from "@/http/cusLevelManagement.js"
import { orderPriorityGetList } from '@/http/orderPriorityManagement.js'
import { customerGetList  } from "@/http/customerManagement.js"
import { cusCompanyGetList } from "@/http/cusCompanyManagement.js"
import { getLinkBookMemberList } from "@/http/NoticManagement.js"
import { getOrgList, getUserList } from '@/http/BranchManagement.js'
import { baseGetChannelList } from '@/http/NoticManagement.js'
import { getMsgTipsList } from "@/http/MsgTips";
import { getListByUserId } from "@/http/NoticManagement.js";
import { uploadHeadImg, getUserInfo } from "@/http/UserManagement.js"
import { covertTreeData } from '@/utils/auth'
import "./css/RightPane.css"
import MessageWS from "../MessageWS/MessageWS.vue"
import { mapState, mapMutations } from "vuex"
import Vue from "vue";

export default {
  components: { MessageWS },
  data() {
    let validateOldPwd = (rule, value, callback) => {
      if (value === "" || value === null) {
        callback(new Error(this.Language("旧密码不能为空")));
      } else {
        callback();
      }
    };
    let validateNewPwd = (rule, value, callback) => {
      if (value === "" || value === null) {
        callback(new Error(this.Language("新密码不能为空")));
      } else if (value.length < 6) {
        callback(new Error(this.Language("密码长度要大于6位")));
      } else {
        callback();
      }
    };
    let validateCheckNewPwd = (rule, value, callback) => {
      if (value === "" || value === null) {
        callback(new Error(this.Language("确认密码不能为空")));
      } else if (value !== this.form_info.newPwd) {
        callback(new Error(this.Language("两次输入密码不一致")));
      } else {
        callback();
      }
    };
    return {
      param: {
        vdnId: JSON.parse(LocalStorage.getItem("obj"))
          ? JSON.parse(LocalStorage.getItem("obj")).vdnId
          : "",
        userId: JSON.parse(LocalStorage.getItem("obj"))
          ? JSON.parse(LocalStorage.getItem("obj")).userId
          : "",
      },
      agpHtmlUrl: process.env.NODE_ENV === 'development'?window.WSSET.devAgpUrl:window.WSSET.prodAgpUrl,
      plugHtmlUrl: process.env.NODE_ENV === 'development'?window.WSSET.devPlugUrl:window.WSSET.prodPlugUrl,
      visible: false,
      top: 0,
      left: 0,
      menuData: null,
      thisMenu: "",
      userObj: JSON.parse(LocalStorage.getItem("obj")),
      IsInfo: false,
      form_info: {
        oldPwd: "",
        newPwd: "",
        checkNewPwd: "",
        picPath: "",
        tel: '',
        mobileTel: '',
        email: '',
        buCode: ''
      },
      rules_form: {
        oldPwd: [{ validator: validateOldPwd }, { required: true, message: '请输入旧密码'}],
        newPwd: [{ validator: validateNewPwd }, { required: true, message: '请输入新密码'}],
        checkNewPwd: [{ validator: validateCheckNewPwd }, { required: true, message: '请再次输入新密码'}],
      },
      bodyBgColor: 'shense',
      sForm: {
        ccOpenFlag: '0',
        extNum: '',
        docTimeLong: 10,
        msgTipTimeLong: 10,
        smallRestTimeLong: 10,
        ccState: '32',
        ccGroupData: [],
        ccSkillData: [],
        olOpenFlag: '0',
        niceName: '',
        maxFollowQty: 1,
        isAuto: '0', //0否1是
        olState: '1',
        olGroupData: [],
        olSkillData: []
      },
      sRules: {
        docTimeLong: {required: true, message: this.Language('请填写文书时长')},
        msgTipTimeLong: {required: true, message: this.Language('请填写消息提示时长')},
        smallRestTimeLong: {required: true, message: this.Language('请填写小休时长')},
        niceName: {required: true, message: this.Language('请填写昵称')},
        maxFollowQty: {required: true, message: this.Language('请填会话上限')},
        olGroupData: {required: true, message: this.Language('请选择在线坐席组')},
        olSkillData: {required: true, message: this.Language('请选择在线技能组')}
      },
      startInfo: false,
      skillGroupData: [],
      agentGroupData: [],
      agentGroupDataAll: [],
      agentGroupDataOnline: [],
      skillGroupDataOnline: [],
      agentData: [],
      showAgentData: [],
      messageNum: 0,
      noticNum: 0,
      onLineNum: 0,
      hotLineNum: 0,
      linkBookList: [],
      linkBookOne: true, //是否只能单选一个手机号
      checkPhone: '',
      checkPhoneMore: [],
      agpBox: null, //agp工具栏容器
      plugBox: null, //工具栏配套容器
      agentDialogTitle: '坐席列表',
      page: 1,
      total: 0,
      targetGroup: null, //选中的坐席组对象
      targetAgent: null, //选中的坐席对象
      smsShow: false,
      sendForm: {
        signtype: '', //签名类型
        content: '', //内容
        priority: '0', //优先级
        isBusiModel: '0', //是否业务模板
        busiModelId: '0', //业务模板id
        modelId: '' //模板id
      },
      templateList: [], //短信模板列表
      smsSignList: [], //短信签名列表
      dynamicTags: [], //短信接收人列表
      inputVisible: false,
      inputValue: '',
      contentNumber: 0,
      sendContentNumber: 0,
      templateContentList: [],
      contentTextareaShow: true,
      sendRules: {
        signtype: {required: true, message: this.Language('短信签名不能为空')}
      },
      groupAndSkills: [],
      toolbarShow: false,
      picPath: 'static/images/004.png',
      agentGroupKey: '',
      agentKey: '',
      openOnlineProp: {
        isOpenOnline: true, //是否已经打开线上客服
        isHandler: false, //是否手动打开、修改信息
      },
      optionList: {
        orderType: [],
        orderForm: [],
        cusLevel: [],
        priorityCode: [],
        orgList: [],
        userList: [],
        cusCompany: [],
        channelList: [],
      },
      tipsList: [], //通知的列表数据 - 最新5条
      noticList: [], //公告的列表数据 - 最新5条
      isTheme: false, //是否使用深浅模式
      hideTheme: false, //是否隐藏选主题
      isRecordExtnum: false, //显示缓存分机提示
      isTuichu: true, //是否显示退出登录按钮
      isEditPwd: false, //是否要修改密码
      codeList: []
    };
  },
  name: "RightPane",
  computed: {
    activeTabName: {
      get() {
        return this.$store.state.navTabs.activeTabName;
      },
      set(value) {
        this.$store.commit("navTabs/setActiveTabName", value);
      },
    },
    ...mapState("navTabs", ["tabList"]),
    linkBookShow: {
      get(){
        if(this.$store.state.navTabs.linkBookShow){
          this.getLinkBookMemberListFn() //打开通讯录时调用接口
        }
        return this.$store.state.navTabs.linkBookShow
      },
      set(value){
        this.$store.commit("navTabs/setLinkBookShow", value);
      }
    },
  },
  filters: {
    //过滤器
    getTimes(time) {
      //将循环出来的时间戳进行转换
      return getTimes(time);
    }
  },
  watch: {
    //清空修改密码
    isEditPwd(val){
      if(!val){
        this.form_info.oldPwd = '';
        this.form_info.newPwd = '';
        this.form_info.checkNewPwd = '';
      }
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
    "$store.state.navTabs.menu": {
      //监听tab右键
      deep: true,
      handler(val, oldVal) {
        this.$nextTick(() => {
          this.visible = val.visible;
          this.top = val.top;
          this.left = val.left;
          this.menuData = val.data;
          this.thisMenu = val.data.activeTabName;
        });
      },
    },
    "$store.state.navTabs.activeTabName": {
      //监听选中的tab变化
      deep: true,
      handler(val, oldVal) {
        if(val == '777'){
          $('.isPos').removeClass('isPos')
        }else{
          $('.isBlock').addClass('isPos')
        }
        this.$nextTick(() => {
          // 组件在更新后触发
          SessionStorage.setItem("tab", val);
        });
      },
    },
    "$store.state.navTabs.hotLineNum": {
      deep: true,
      handler(val, oldVal){
        this.hotLineNum = val
      }
    },
    "$store.state.navTabs.onLineNum": {
      deep: true,
      handler(val, oldVal){
        this.onLineNum = val
      }
    },
    //外链页面通过postMessage发送短信
    "$store.state.navTabs.smsPhoneNum":{
      deep: true,
      handler(val, oldVal){
        if(val !== 0){
          this.openSmsFn()
          this.dynamicTags = []
          let arr = val.split(',')
          arr.forEach((o)=>{
            this.dynamicTags.push({label: o, mobileNo: o});
          })
          //处理完后重置
          this.$nextTick(()=>{
            this.$store.state.navTabs.smsPhoneNum = 0
          })
        }
      }
    },
    //头像更改
    "$store.state.navTabs.picPath": {
      deep: true,
      handler(val, oldVal){
        this.picPath = val?val:'static/images/004.png'
      }
    },
    //当前显示的坐席列表里各坐席状态
    "$store.state.navTabs.agentStatus": {
      deep: true,
      handler(val, oldVal){
        if(val){
          this.showAgentData = []
          //把状态加入到坐席列表里
          this.agentData.map((m)=>{
            val.map((v)=>{
              if(v.AgentID && (m.userId == v.AgentID)){
                if(this.agentDialogTitle == '坐席列表 (抢接坐席)'){
                  if(v.AgentStatus == 64){
                    //振铃 - 抢接
                    m.status = 64
                    this.showAgentData.push(m)
                  }
                }else{
                  if(v.AgentStatus == 32){
                    //空闲 - 可以邀请-呼叫-转移
                    m.status = 32
                    this.showAgentData.push(m)
                  }
                }
              }
            })
          })
          // console.log("this.showAgentData")
          // console.log(this.showAgentData)
          this.showAgentData = this.distinctPlus(this.showAgentData)
          //处理完后重置
          this.$nextTick(()=>{
            this.$store.state.navTabs.agentStatus = ''
          })
        }
      }
    },
    agentGroupKey(){
      if(this.targetGroup){
        //已有选中的坐席组，筛查后要选中对应的行高亮
        this.$refs.groupTable.setCurrentRow(this.targetGroup);
      }
    },
    agentKey(){
      if(this.targetAgent){
        //已有选中的坐席，筛查后要选中对应的行高亮
        this.$refs.agentTable.setCurrentRow(this.targetAgent);
      }
    },
    //通知数变动时
    messageNum(val){
      if(val){
        this.getMsgTipsListFn()
      }else{
        this.tipsList = []
      }
    },
    //公告数变动时
    noticNum(val){
      if(val){
        this.noticeGetListByUserIdFn()
      }else{
        this.noticList = []
      }
    },
  },
  created() {
    this.initVdnId();

    //-----个性定制主题配置----------
    if(window.projectConfig && window.projectConfig.isTheme){
      this.isTheme = true
      this.bodyBgColor = window.projectConfig.isHRSZ?'shense':'qianse'
      if(window.projectConfig.isHRSZ){
        //华润守正隐藏主题
        this.hideTheme = true
      }
    }

    if(LocalStorage.getItem('bodyBgColor')){
      this.bodyBgColor = LocalStorage.getItem('bodyBgColor')
    }else{
      LocalStorage.setItem('bodyBgColor', this.bodyBgColor);
    }

    document.body.className = this.bodyBgColor

    let baseURL;
    if (process.env.NODE_ENV === 'development') {
      baseURL = window.APIURL.devUrlApi
    } else {
      baseURL = window.APIURL.prodUrlApi
    }
    LocalStorage.setItem('baseURL', baseURL)

    //英文版本 - 给body加个标记
    if(window.location.href.indexOf('Lang=EN') > -1){
      document.body.setAttribute('data-lang', 'EN');
    }

    if(window._CONFIG.isRecordExtnum){
      this.isRecordExtnum = window._CONFIG.isRecordExtnum
    }

    //润工作进来不显示退出登录按钮
    if(LocalStorage.getItem('isHrWork')){
      this.isTuichu = false;
    }
    
  },
  mounted() {
    this.picPath = this.$store.state.navTabs.picPath

    this.optionList = JSON.parse(LocalStorage.getItem('optionList'))||{}
    if(window._CONFIG.isSass){
      if ('orderType' in this.optionList==false) this.fetchOrderTypeList()
      if ('orderForm' in this.optionList==false) this.orderFormDesignGetListFn()
      if ('cusLevel' in this.optionList==false) this.fetchCusLevelList()
      if ('priorityCode' in this.optionList==false) this.fetchOrderPriorityList()
      if ('orgList' in this.optionList==false) this.fetchGroupListFn()
      if ('userList' in this.optionList==false) this.fetchUserListFn()
      if ('cusCompany' in this.optionList==false) this.cusCompanyGetListFn()
      if ('customer' in this.optionList==false) this.cusGetListFn()
    }
    if ('channelList' in this.optionList==false) this.channelListFn()

    this.findBuCodeFn()
    this.getAgentGroupList()
    this.getAgentSkillList()
    this.getAgentGroupListUser(1) //热线的坐席组
    this.getAgentGroupListUser(8) //在线的坐席组
    this.getSkillGroupList(1) //热线的技能组
    this.getSkillGroupList(8) //在线的技能组
    this.getSmsSignListFn()
    this.getUserGroupAndSkillListFn()
    this.getAgentListByGroupIdFn(1, false) //全部坐席
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))

  },
  methods: {
    ...mapMutations("navTabs", ["closeTab"]),
    ...mapMutations("navTabs", ["addTab"]),
    ...mapMutations("navTabs", ["openMenu"]), //打开右键
    ...mapMutations("navTabs", ["closeOthers"]), //关闭其他
    ...mapMutations("navTabs", ["closeAll"]), //关闭所有
    formatterTel(row){
      let returnStr = ''
      if(this.GLOBAL.power.is_1030){ //号码隐藏All
        let mobileNo = this.hidePhoneNumAll(row.mobileNo)
        returnStr = row.label.replace(row.mobileNo, mobileNo)
      } else if(this.GLOBAL.power.is_1031){ //号码替换
        let mobileNo = this.hidePhoneNum(row.mobileNo)
        returnStr = row.label.replace(row.mobileNo, mobileNo)
      } else {
        returnStr = row.label
      }
      return returnStr;
    },
    beforeunloadHandler (e) {
      this.closecloseAllTags()
      return '关闭提示'
    },
    closeOthersTags() {
      //关闭其他tab
      this.closeOthers();
    },
    closecloseAllTags() {
      //关闭所有tab
      this.closeAll();
    },
    closeThis() {
      //关闭当前tab
      this.closeTab(this.thisMenu);
    },
    //刷新
    refreshSelectedTag() {
      const self = this
      let viewObj = self.$store.state.navTabs.tabList.filter(item => {
        return self.thisMenu == item.name
      })
      if (viewObj[0].viewName=='Assistant'||viewObj[0].viewName=='Monitor') {
        if (viewObj[0].viewName=='Assistant') {
          let obj = $("#pane-"+viewObj[0].name+" iframe")[0]
          obj.contentWindow.postMessage({message: 'closeZS'}, '*')
        } else if (viewObj[0].viewName=='Monitor') {
          let obj = $("#pane-"+viewObj[0].name+" iframe")[0]
          obj.contentWindow.postMessage({message: 'closeJK'}, '*')
        }
        setTimeout(function() {
          self.refreshTabFn() //刷新当前tab
        }, 500)
      } else {
        if (self.thisMenu == '888' && window.APIURL.aiassitantUrl) {
          $('#aiassitant')[0].contentWindow.postMessage({ message: "reloadAss" }, "*")
          setTimeout(function() {
            self.refreshTabFn() //刷新当前tab
          }, 500)
        } else self.refreshTabFn() //刷新当前tab
      }
    },
    //刷新当前tab
    refreshTabFn() {
      const self = this
      self.$store.state.navTabs.tabList.forEach((item) => {
        if (item.name == self.thisMenu) {
          item.isLoad = false;
          self.$nextTick(() => {
            item.isLoad = true;
            if(self.thisMenu == '777'){
              //线上客服的页面刷新时，重新发送配置信息
              this.sendMessageToOnlineFn(this.sForm)
            }
          });
        }
      });
    },
    // 上传图片前的过滤
    beforeAvatarUpload (file) {
      let types = ['image/jpeg', 'image/jpg', 'image/png'];
      const isImage = types.includes(file.type);
      const isLt2M = (file.size / 1024 / 1024) < 2

      if (!isImage) {
        this.$Msg.error('上传头像图片只能是 JPG、JPEG、PNG 格式!')
      } else if (!isLt2M) {
        this.$Msg.error('上传头像图片大小不能超过 2MB!')
      }
      return isImage && isLt2M
    },
    uploadImg(imgFile) {
      let formData = new FormData()
      formData.append("media", imgFile.file)
      formData.append("userId", this.param.userId)
      uploadHeadImg(formData).then(res => {
        if (res.retCode == 1) {
          this.$Msg.success('操作成功');
          this.form_info.picPath = res.data
          this.$store.state.navTabs.picPath = res.data
        }
      })
    },
    handleUploadChange(file, fileList) {
      this.$refs.uploadAvatar.clearFiles()
    },
    OpenInfo() {
      //修改资料弹窗
      this.IsInfo = true;
      this.form_info.picPath = this.picPath
      let data = {
        vdnId: this.param.vdnId,
        userId: this.param.userId
      }
      getUserInfo(data).then(res => {
        if(res && res.retCode == 1){
          this.form_info.mobileTel = res.data.mobileTel;
          this.form_info.tel = res.data.tel;
          this.form_info.email = res.data.email;
        }
      })
    },
    //修改密码
    setInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.param.userId,
            vdnId: this.param.vdnId,
            ...this.form_info
          };
          delete data.checkNewPwd;
          let pwdd = this.$store.state.navTabs.publicKey || LocalStorage.getItem("getPublicKey");
          if (pwdd && data.oldPwd && data.newPwd) {
            //如果有密匙则加密
            data.oldPwd = this.$encryptedData(pwdd, this.form_info.oldPwd + "|" + new Date().getTime());
            data.newPwd = this.$encryptedData( pwdd, this.form_info.newPwd + "|" + new Date().getTime());
          }
          updateUserPwd(data).then((res) => {
            if (res && res.retCode == 1) {
              this.$Msg.success('修改成功');
              this.IsInfo = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeBack(name) {
      //关闭弹窗之后需要重置那些验证
      this.$refs[name].resetFields();
      this.isEditPwd = false;
    },
    logout() {
      //退出
      this.$confirm("确定要退出吗？", this.Language("提示"), {
        confirmButtonText: this.Language("确定"),
        cancelButtonText: this.Language("取消"),
        customClass: "new-alert-box",
        confirmButtonClass: "btn-custom-cancel",
        type: "warning",
      }).then(() => {
        this.logoutCallFn()
      })
      .catch(() => {});
    },
    //调用退出账号接口
    logoutCallFn(){
      let data = {
        vdnId: this.param.vdnId,
      }
      let objZS = null;
      let objJK = null;
      this.$store.state.navTabs.tabList.forEach((item) => {
        let itemObj = $("#pane-"+item.name+" iframe");
        if (item.viewName == 'Assistant') objZS = itemObj[0]
        if (item.viewName == 'Monitor') objJK = itemObj[0]
        //退出登录时，向所有子系统发送清空缓存信息
        if(itemObj && itemObj.length){
          itemObj[0].contentWindow.postMessage({message: 'logotSysterm'}, '*')
          console.log('已发送退出信息到页面：' + item.name)
        }
      })
      if (objZS) objZS.contentWindow.postMessage({message: 'closeZS'}, '*')
      if (objJK) objJK.contentWindow.postMessage({message: 'closeJK'}, '*')
      logout(data).then((res) => {
        let hotTabArr = LocalStorage.getItem('hotTabArr');
        let record_extnum = LocalStorage.getItem('record_extnum');
        //在线的页面有排序功能需要记录
        let rightTab = '', olUrl = '';
        if(window._CONFIG.online_url){
          olUrl = window._CONFIG.online_url.replace('https://', '');
          olUrl = olUrl.replace('http://', '');
          olUrl = olUrl.split('/');
          if(olUrl.length > 1){
            olUrl = olUrl[1];
          }
          rightTab = window.localStorage.getItem('rightTab_' + olUrl);
        }
        LocalStorage.clear();
        SessionStorage.clear()
        if(hotTabArr){
          LocalStorage.setItem('hotTabArr', hotTabArr);
        }
        if(record_extnum){
          LocalStorage.setItem('record_extnum', record_extnum);
        }
        if(rightTab){
          window.localStorage.setItem('rightTab_' + olUrl, rightTab);
        }
        if(this.bodyBgColor){
          LocalStorage.setItem('bodyBgColor', this.bodyBgColor)
        }
        let Lang = '';
        if(window.location.href.indexOf('?') > -1){
          Lang = window.location.href.split('?')[1];
        }
        console.log('手动触发退出......');
        if(Lang && Lang.indexOf('vdnId') > -1){
          this.$router.push("/?" + Lang);
        }else{
          this.$router.push("/?vdnId=" + this.param.vdnId + (Lang?'&' + Lang:''));
        }
        this.$store.commit("navTabs/LOGOUT");
        window.location.reload()
      });
    },
    initVdnId() {
      this.userObj = JSON.parse(LocalStorage.getItem("obj"));
    },
    closeMenu() {
      this.$store.commit("navTabs/isopenMenu", false);
    },
    //选择不同的主题颜色
    changeBgColor(e){
      LocalStorage.setItem('bodyBgColor', this.bodyBgColor)
      document.body.className = this.bodyBgColor
      //往已打开的子系统发送信息替换皮肤
      let len = window.frames.length
      for(var i = 0; i < len; i++){
        window.frames[i].postMessage({message: 'bgcolor', bgColor: this.bodyBgColor}, '*')
      }
    },
    //发送信息到线上客服
    sendMessageToOnlineFn(form){
      let olGroupData = [], olSkillData = []
      if (form.olGroupData.length) {
        form.olGroupData.map(groupId => {
          let obj = this.agentGroupDataOnline.filter(item => { return item.groupId == groupId })
          olGroupData.push(obj[0])
        })
      }
      if (form.olSkillData.length) {
        form.olSkillData.map(skillId => {
          let obj = this.skillGroupDataOnline.filter(item => { return item.skillId == skillId })
          olSkillData.push(obj[0])
        })
      }
      let postJson = {
        message: 'olOptions',
        niceName: form.niceName, //昵称
        maxFollowQty: form.maxFollowQty, //会话上限
        olState: form.olState, //在线状态
        olGroupData: olGroupData, //签入的坐席组
        olSkillData: olSkillData, //签入的技能组
        agentId: this.param.userId,
        isHandler: this.openOnlineProp.isHandler,
        isOpenOnline: this.openOnlineProp.isOpenOnline,
      }
      console.log(postJson)
      setTimeout(()=>{
        document.getElementById('onlineAgent').contentWindow.postMessage(postJson, '*')
      }, 2000)
    },
    //重构数组
    returnReSet(list, key){
      let arr = []
      if(list && list.length > 0){
        list.map((o)=>{
          arr.push(o[key])
        })
      }
      return arr
    },
    //获取用户技能组列表
    getSkillGroupList(type) {
      return new Promise((resolve, reject) => {
        let data = {
          vdnId: this.param.vdnId,
          userId: this.param.userId,
          mediaTypeId: type
        }
        getSkillListByUserId(data).then((res) => {
          if (res && res.retCode == 1) {
            if(type == 1){
              this.skillGroupData = res.data;
              LocalStorage.setItem('skillGroupData', JSON.stringify(this.skillGroupData))
              resolve(res.data)
            }else{
              this.skillGroupDataOnline = res.data;
              LocalStorage.setItem('skillGroupDataOnline', JSON.stringify(this.skillGroupDataOnline))
              resolve(res.data)
            }
          }
        })
      })
    },
    //获取用户坐席组列表
    getAgentGroupListUser(type) {
      return new Promise((resolve, reject) => {
        let data = {
          vdnId: this.param.vdnId,
          userId: this.param.userId,
          mediaTypeId: type
        }
        getGroupListByUserId(data).then((res) => {
          if (res && res.retCode == 1) {
            if(type == 1){
              this.agentGroupData = res.data;
              LocalStorage.setItem('agentGroupData', JSON.stringify(this.agentGroupData))
              resolve(res.data)
            }else{
              this.agentGroupDataOnline = res.data;
              LocalStorage.setItem('agentGroupDataOnline', JSON.stringify(this.agentGroupDataOnline))
              resolve(res.data)
            }
          }
        })
      })
    },
    //获取坐席组列表 - 全部
    getAgentGroupList() {
      let data = {
        vdnId: this.param.vdnId
      }
      getGroupList(data).then((res) => {
        if (res && res.retCode == 1) {
          this.agentGroupDataAll = res.data;
          SessionStorage.setItem('allGroupList', JSON.stringify(this.agentGroupDataAll))
        }
      })
    },
    //获取技能组列表 - 全部
    getAgentSkillList() {
      let data = {
        vdnId: this.param.vdnId
      }
      getSkillList(data).then((res) => {
        if (res && res.retCode == 1) {
          SessionStorage.setItem('allSkillList', JSON.stringify(res.data))
        }
      })
    },
    //获取部门列表
    fetchGroupListFn() {
      getOrgList({
        isValid: '',
        orgName: '',
        vdnId: this.param.vdnId
      }).then(res => {
        if (res && res.retCode == 1) {
          this.optionList['orgList'] = covertTreeData(res.data,'0')
          LocalStorage.setItem('optionList', JSON.stringify(this.optionList))
        }
      })
    },
    //渠道列表
    channelListFn() {
      let data = {
        vdnId: this.param.vdnId
      }
      baseGetChannelList(data).then((res) => {
        if (res && res.retCode == 1) {
          this.optionList['channelList'] = res.data
          LocalStorage.setItem('optionList', JSON.stringify(this.optionList))
        }
      })
    },
    //客户列表
    cusGetListFn() {
      let showData = [{fieldName: "cusName"}]
      let params = {
        vdnId: this.param.vdnId,
        pageSize: 999,
        pageNo: 1,
        queryData: [],
        showData: showData
      }
      customerGetList(params).then(res => {
        if (res && res.retCode === 1) {
          this.optionList['customer'] = res.data.list
          LocalStorage.setItem('optionList', JSON.stringify(this.optionList))
        }
      })
    },
    //客户公司列表
    cusCompanyGetListFn() {
      let showData = [{fieldName: "name"}]
      let params = {
        vdnId: this.param.vdnId,
        pageSize: 999,
        pageNo: 1,
        queryData: [],
        showData: showData
      }
      cusCompanyGetList(params).then(res => {
        if (res && res.retCode === 1) {
          this.optionList['cusCompany'] = res.data.list
          LocalStorage.setItem('optionList', JSON.stringify(this.optionList))
        }
      })
    },
    //获取人员列表
    fetchUserListFn() {
      let params = {
        orgId: '',
        userKey: '',
        vdnId: this.param.vdnId
      }
      getUserList(params).then(res => {
        if(res && res.retCode == 1){
          this.optionList['userList'] = res.data
          LocalStorage.setItem('optionList', JSON.stringify(this.optionList))
        }
      })
    },
    //客户等级
    fetchCusLevelList() {
      cusLevelGetList({
        pageNo: 1,
        pageSize: 999,
        vdnId: this.param.vdnId,
        isValid: 1
      }).then(res => {
        if(res && res.retCode == 1){
          this.optionList['cusLevel'] = res.data.list
          LocalStorage.setItem('optionList', JSON.stringify(this.optionList))
        }
      })
    },
    //优先级
    fetchOrderPriorityList() {
      orderPriorityGetList({
        pageNo: 1,
        pageSize: 999,
        vdnId: this.param.vdnId,
      }).then(res => {
        if(res && res.retCode == 1){
          this.optionList['priorityCode'] = res.data.list
          LocalStorage.setItem('optionList', JSON.stringify(this.optionList))
        }
      })
    },
    //工单类型
    fetchOrderTypeList() {
      orderTypeGetList({
        pageNo: 1,
        pageSize: 999,
        vdnId: this.param.vdnId
      }).then(res => {
        if(res && res.retCode == 1){
          this.optionList['orderType'] = res.data.list
          LocalStorage.setItem('optionList', JSON.stringify(this.optionList))
        }
      })
    },
    //工单表单列表
    orderFormDesignGetListFn() {
      let data = { 
        vdnId: this.param.vdnId,
        pageNo: 1,
        pageSize: 999
      }
      orderFormDesignGetList(data).then((res) => {
        if (res && res.retCode === 1) {
          this.optionList['orderForm'] = res.data.list
          LocalStorage.setItem('optionList', JSON.stringify(this.optionList))
        }
      })
    },
    //更新公告未读数
    noticObjFn(res){
      this.noticNum = res.total
    },
    //更新通知未读数
    msgObjFn(res){
      this.messageNum = res.total
    },
    //打开对应页面tab
    goToUrl(url){
      let item = null
      let menuList = this.$store.state.navTabs.menuList
      item = this.getMenuItem(menuList, url)
      if(item){
        this.addTab(item)
      }
    },
    //通讯录人员列表数据
    getLinkBookMemberListFn(){
      let data = {
        vdnId: this.param.vdnId
      }
      getLinkBookMemberList(data).then(res=>{
        if(res){
          if(res.retCode == 1){
            this.linkBookList = this.getTreeLabelFn(res.data)
          }
        }
      })
    },
    //递归处理树结构
    getTreeLabelFn(list){
      //需要先处理数据统一表示 
      for(let i = 0;i < list.length;i++){
        list[i].disabled = false
        list[i].label = list[i].name
        if(list[i].isType==1){
          this.getTreeLabelFn(list[i].children)
        }else{
          list[i].label =  list[i].label + '[' + list[i].mobileNo + ']'
        }
      }
      return list
    },
    //选择通讯录号码
    setLinkBook(){
      if(this.linkBookOne){
        //单选号码
        let node = this.checkPhone
        if(!node.mobileNo){
          this.$Msg.error('请选择有电话号码的通讯人员');
        }else{
          this.closeLinkBookFn()
        }
      }else{
        //多选号码
        let nodes = this.checkPhoneMore
        if(nodes.length == 0){
          this.$Msg.error('请选择通讯人员');
        }else{
          this.dynamicTags = this.dynamicTags.concat(nodes);
          this.dynamicTags = this.distinct(this.dynamicTags, 'mobileNo'); //去重
          this.closeLinkBookFn()
        }
      }
    },
    //关闭通讯录弹窗
    closeLinkBookFn(){
      this.linkBookShow = false
      this.linkBookOne = true //默认单选
      this.$refs.tree.setCurrentKey(null)
      this.checkPhone = ''
      this.checkPhoneMore = []
    },
    //选中坐席组查询组内坐席
    groupRowClickFn(row){
      this.targetGroup = row
      this.getAgentListByGroupIdFn(1, true)
    },
    //选中坐席
    agentRowClickFn(row){
      this.targetAgent = row
    },
    //通过坐席组获取坐席列表
    getAgentListByGroupIdFn(page, type){
      this.page = page
      let data = {
        vdnId: this.param.vdnId,
        groupId: this.targetGroup?this.targetGroup.groupId:'',
        pageNo: page,
        pageSize: 9999
      }
      getAgentListByGroupId(data).then((res) => {
        if(res){
          if(res.retCode == 1){
            this.agentData = res.data.list
            this.showAgentData = []
          }
        }
      })
    },
    //打开在线排队页面
    openOnlineFn(){
      this.activeTabName = '777'
      if(this.onLineNum > 0){
        document.getElementById('onlineAgent').contentWindow.postMessage({message: 'openOL'}, '*')
      }
    },
    //打开短信发送快捷窗口
    openSmsFn(){
      this.getSmsTemplateListFn();
    },
    //关闭短信发送弹窗
    closeSmsFn(){
      this.sendForm = {
        signtype: '',
        content: '',
        taskName: '',
        priority: '0',
        mobileNoList: [],
        isBusiModel: '0',
        busiModelId: '0',
        modelId: ''
      }
      this.dynamicTags = []
      this.contentNumber = 0
      this.sendContentNumber = 0
      this.templateContentList = []
      this.contentTextareaShow = true
      this.$nextTick(()=>{
        this.$refs.sendForm.clearValidate()
      })
      this.smsShow = false
    },
    //确认发送短信
    sendSmsFn(){
      let _sf = this.sendForm
      let data = {
        vdnId: this.param.vdnId,
        signtype: _sf.signtype,
        content: _sf.content,
        taskName: '短信快捷发送' + (new Date()).getTime(),
        priority: _sf.priority,
        execDate: null,
        state: '0',
        mobileNoList: [],
        isBusiModel: _sf.isBusiModel,
        busiModelId: _sf.busiModelId,
        modelId: _sf.modelId,
        id: '',
        busiModelParam: []
      }
      this.$refs.sendForm.validate((valid)=>{
        if(valid){
          //业务模板里的输入框不能为空
          let errorFlag = false;
          let busiModelParam = [];
          if(_sf.isBusiModel == 1 && this.templateContentList != null && this.templateContentList.length > 0){
            let resultContent = ''
            for (let i = 0; i < this.templateContentList.length; i++) {
              let item = this.templateContentList[i];
              if(item.type == 'disabled'){
                resultContent += '${'+item.placeholder+'}'
                if(item.value){
                  busiModelParam.push({paramName: item.placeholder, paramValue: item.value});
                }
              }else if(item.type == 'input'){
                resultContent += item.value
                // 输入框不能为空
                if(!item.value){
                  errorFlag = true;
                  this.$Msg.error("模板<"+item.placeholder+">框不能为空")
                  break;
                }
                busiModelParam.push({paramName: item.placeholder, paramValue: item.value});
              }else{
                resultContent += item.value
              }
            }
            data.content = resultContent
          }
          if(errorFlag){
            return false
          }
          if(data.content == null || data.content == ''){
            this.$Msg.error("发送内容不能为空")
            return false
          }
          let errorCount = 0;
          let mobileNoList = []
          this.dynamicTags.map((r)=>{
            if(this.isCustomFormatFn(r.mobileNo.trim())){
              let mobileNo = r.mobileNo.trim()
              let receiver = r.label.trim()
              mobileNoList.push({mobileNo: mobileNo, receiver: receiver})
            }else if(this.isMobileNoFn(r.mobileNo.trim())){
              let mobileNo = r.mobileNo.trim()
              mobileNoList.push({mobileNo: mobileNo})
            }else if(r.mobileNo.trim().length > 0){
              // 空表示不小心多打的符号
              errorCount++
            }
          })
          if(errorCount > 0){
            this.$Msg.error("发送号码有误, 错误数量:" + errorCount)
            return false
          }
          if(mobileNoList.length == 0){
            this.$Msg.error("发送手机号码不能为空")
            return false
          }
          if(mobileNoList.length > this.maxSendNumber){
            this.$Msg.error("不能超过最大短信发送限制999条")
            return false
          }
          data.mobileNoList = JSON.stringify(mobileNoList)
          data.busiModelParam = JSON.stringify(busiModelParam);
      
          addInfo(data).then(res => {
            if(res && res.retCode === 1) {
              this.closeSmsFn()
              this.$Msg.success('发送成功');
            }
          })
        }
      })
    },
    //获取短信模板数据
    getSmsTemplateListFn(){
      let data = {
        vdnId: this.param.vdnId
      }
      getSmsTemplateList(data).then(res => {
        if(res){
          if(res.retCode == 1){
            this.templateList = res.data?res.data:[]
            this.smsShow = true
          }
        }
      })
    },
    //获取短信签名数据
    getSmsSignListFn() {
      const data = {
        dictTypeCode: "SmsSign" ,
        vdnId: this.param.vdnId,
      }
      getDictList(data).then(res => {
        if (res && res.retCode === 1) {
            this.smsSignList = res.data?res.data:[];
        }
      });
    },
    //删除已选的接收人
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    //自定义发送短信手机号
    showInput(){
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        if(this.checkMobile(inputValue)){
          let go = true;
          this.dynamicTags.map((o)=>{
            if(o.mobileNo == inputValue){
              go = false;
              this.$Msg.error('已有相同的手机号码')
            }
          })
          if(go){
            this.dynamicTags.push({label: inputValue, mobileNo: inputValue});
            this.inputVisible = false;
            this.inputValue = '';
          }
        }else{
          this.$Msg.error('请输入正确的手机号码')
        }
      }else{
        this.inputVisible = false;
        this.inputValue = '';
      }
    },
    //打开选择接收人手机号
    openLinkBookFn(){
      this.linkBookOne = false //转为多选手机号
      this.linkBookShow = true
    },
    //检查短信字数
    changeContentFn(){
      let count = 0
      if(this.sendForm.isBusiModel == 1){
        this.templateContentList.map((item)=>{
          count += item.value.length
        })
      }else{
        count = this.sendForm.content.length
      }
      this.contentNumber = count
      this.sendContentNumber = count==0?0:((parseInt(count / 55)) + 1)
    },
    //选择模板
    setTemplateFn(){
      let templateItem = this.$refs.smsTpl.getCheckedNodes(true)
      templateItem = templateItem[0].data
      if(templateItem){
        this.sendForm.isBusiModel = templateItem.isBusiModel
        this.sendForm.busiModelId = templateItem.busiModelId
        this.sendForm.modelId = templateItem.id
        if(templateItem.isBusiModel == 1){
          this.templateContentList = []
          this.contentTextareaShow = false
          this.convertContentFn(templateItem.content)
        }else{
          this.contentTextareaShow = true
          this.sendForm.content = templateItem.content 
        }
        this.changeContentFn()
      }
    },
    // 转换内容
    convertContentFn(content){
      let resultContent = content;
      let inputArray = resultContent.match(/\$\{.+?\}/g)
      let textArray = resultContent.split(/\$\{.+?\}/g)
      if(inputArray == null || inputArray.length == 0){
        return resultContent
      }
      for(let i=0;i<(inputArray.length+textArray.length);i++){
        if(i%2 == 0){
          this.templateContentList.push({"type":"text","placeholder":'',"value":textArray[i/2]})
        }else{
          let name = inputArray[(i-1)/2].substring(2, inputArray[(i-1)/2].length-1)
          if("姓名" == name || "号码" == name){
            this.templateContentList.push({"type":"disabled","placeholder":name,"value": ''})
          }else{
            this.templateContentList.push({"type":"input","placeholder":name,"value": ''})
          }
        }
      }
    },
    // 是否号码
    isMobileNoFn(mobileNo){
      return this.checkMobile(mobileNo)
    },
    // 是否定义格式
    isCustomFormatFn(str){
      return /^.+?\[1[3456789]\d{9}\]$/.test(str)
    },
    //获取当前坐席的组与技能
    getUserGroupAndSkillListFn(callback){
      let data = {
        vdnId: this.param.vdnId
      }
      getUserGroupAndSkillList(data).then((res)=>{
        if(res){
          if(res.retCode == 1){
            this.groupAndSkills = res.data
          }
        }
        if(callback){
          callback()
        }
      })
    },
    //去重加强版
    distinctPlus(arr) {
			var i, j,
				len = arr.length;
			for (i = 0; i < len; i++) {
				for (j = i + 1; j < len; j++) {
					if (arr[i].userId == arr[j].userId) {
						arr.splice(j, 1);
						len--;
						j--;
					}
				}
			}
			return arr;
		},
    //获取消息提醒列表 - 只获取前5条
    getMsgTipsListFn() {
      let data = {
        vdnId: this.param.vdnId,
        begDate: '',
        endDate: '',
        isRead: '0',
        pageSize: 5,
        pageNo: 1
      }
      getMsgTipsList(data).then((res) => {
        if (res && res.retCode == 1) {
          this.tipsList = res.data.list;
        }
      });
    },
    //获取公告提醒列表 - 只获取前5条
    noticeGetListByUserIdFn(){
      let data = {
        vdnId: this.param.vdnId,
        begDate: '',
        endDate: '',
        isRead: '0',
        pageSize: 5,
        pageNo: 1
      }
      getListByUserId(data).then((res) => {
        if (res && res.retCode == 1) {
          this.noticList = res.data.list;
        }
      });
    },
    byIdGoToUrl(type, item){
      if(type == 'tip'){
        this.goToUrl('MsgTips/MsgTips')
        this.$store.state.navTabs.openTipObj = item
      }else if(type == 'notice'){
        this.goToUrl('Notic/MyNoticManagement')
        this.$store.state.navTabs.openNoticObj = item
      }
    },
    //获取业务单元
    findBuCodeFn(){
      findBuCode().then(res => {
        if (res && res.retCode == 1) {
          this.codeList = res.data;
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.my-im span {
  cursor: pointer;
  color: #535862;
}
.my-im span i {
  font-size: 26px;
  margin-right: 3px;
  vertical-align: sub;
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  color: #353A42;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
    &:hover {
      background: #eee;
    }
  }
}
.pop-item{
  border-bottom: 1px solid #EBEEF5;
}
.pop-item ul{
  overflow: hidden;
}
.one-ul li{
  float: left;
  width: 33.33%;
  line-height: 26px;
  box-sizing: border-box;
  padding: 10px 0 10px 15px;
}
.two-ul{
  padding: 5px 0;
}
.two-ul li{
  padding: 5px 15px;
  box-sizing: border-box;
}
.two-ul li:hover,
.pop-logout:hover{
  background-color: #F2F8FE;
}
.pop-logout{
  text-align: right;
  padding: 10px 15px;
  cursor: pointer;
}
.pop-item p{
  padding: 10px 15px;
}
.pop-radio-group{
  padding-bottom: 10px;
}
.pop-radio-group .el-radio{
  width: 33.33%;
  padding: 5px 15px;
  box-sizing: border-box;
  margin: 0;
}
.transfer_item{
  border: #DCDFE6 1px solid;
  height: 400px;
  margin-top: 10px;
  overflow: auto;
}
.head-top >>> .line_badge .el-badge__content{
  top: 9px!important;
}
.edit_p_box{
  padding: 0 15px;
  border-radius: 6px;
  border: #C0C4CC 1px solid;
  min-height: 30px;
  outline: none;
}
.edit_p_box:focus{
  border-color: #409EFF;
}
.el-tag{
  margin-right: 10px;
}
.input-new-tag {
  width: 150px;
  margin-right: 10px;
  vertical-align: bottom;
}
.button-new-tag{
  margin-right: 10px;
  text-align: left;
}
.numFlag {
  color: #3196fb;
  font-weight: bold;
}
.passWord-box{
  width: calc(100% - 168px);
}
.img-btn{
  text-align: center;
}
.avatarImg-box{
  margin-left: 20px;
  width: 148px;
}
.avatarImg{
  border: 2px #efefef solid;
  border-radius: 100%;
  width: 90px;
  height: 90px;
}
.avatarImg-s{
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
.avatarTips{
  margin-top: 12px;
  font-size: 12px;
  color: #989DAA;
  text-align: justify;
}
.isBlock #pane-777{
  display: block!important;
  width: 100%;
  height: 100%;
}
.isPos #pane-777{
  position: absolute;
  left: -300%;
}
.right_top_card{
  padding: 5px 10px;
}
.right_top_card:hover{
  background-color: #0094ff1f;
}
.call_btn_open{
  font-size: 60px;
  color: #41C663;
  margin: 0 15px;
  cursor: pointer;
}
.call_btn_close{
  font-size: 60px;
  color: #F24A45;
  margin: 0 15px;
  cursor: pointer;
}
.dialogBg{
  position: absolute;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% calc(100% - 5px);
  width: calc(100% + 378px);
  height: calc(100% + 382px);
  z-index: -1;
  top: -190px;
  left: -190px;
  animation: bgAnimate 4s linear infinite;
}
@keyframes bgAnimate {
  5% {
    background-image: url('../../../static/images/tpBg1.png');
  }
  15% {
    background-image: url('../../../static/images/tpBg2.png');
  }
  20% {
    background-image: url('../../../static/images/tpBg3.png');
  }
  25% {
    background-image: url('../../../static/images/tpBg4.png');
  }
}
</style>
<style>
@keyframes flickerA {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  75% {
    opacity: 1;
  }
}
.LDtan .el-dialog__header{
  text-align: center;
  animation: flickerA 2s linear infinite;
}
</style>



// WEBPACK FOOTER //
// RightPane.vue?1c4d8f2a